import React, {ReactElement} from 'react';
import closeIcon from '../../assets/images/cross-icon.svg';

type ModalProps = {
  children?: React.ReactNode;
  title?: string;
  header?: string;
  isVisible?: boolean;
  onModalClosed?: () => void;
};

const Modal: React.FC<ModalProps> = ({
  title,
  isVisible = false,
  onModalClosed,
  children = null,
  header,
}: ModalProps): ReactElement => {
  const _onCloseClick = () => {
    console.log('use the local state to close the modal');
    if (onModalClosed) onModalClosed();
  };
  return (
    <div
      onClick={_onCloseClick}
      className={`fixed backdrop-filter bg-black bg-opacity-60 transition-opacity duration-500 ease-in-out ${
        isVisible ? 'opacity-100  z-50 inset-0' : 'opacity-0 z-0 w-0 h-0'
      }`}>
      <div
        onClick={e => e.stopPropagation()}
        className={`tranform ${
          isVisible ? '-translate-y-36' : ''
        } absolute bg-white rounded-t-3xl top-20 bottom-0 left-0 right-0 transition-transform ease-in-out duration-1000`}>
        <div className="h-full overflow-y-auto">
          <div className="modal-handle bg-light_gray opacity-50 rounded ml-auto mr-auto mt-2 ">
            &nbsp;
          </div>
          <div className=" mx-auto mb-1">
            <div className="  right-0 top-6 left-0 mt-8">
              <span className="text-center font-bold text-xl block font-roboto">
                {title}
              </span>
            </div>
            <div
              onClick={_onCloseClick}
              className=" absolute top-12 md:-top-8 -right-1 mr-4 -mt-6 cross-icon-modal ">
              <img src={closeIcon} />
            </div>
          </div>
          <div className="pt-8 pb-4 font-roboto ">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default Modal;

/**
<div className="modal">
      <div className="modal-content">
        <div className="modal-header">
          <h4 className="modal-title Shape">Modal title</h4>
        </div>
        <div className="modal-body">This is modal content</div>
        <div className="modal-footer">
          <button> CLose </button>
        </div>
      </div>
    </div>
 */
